<script>
export default {
  methods: {
    openPasswordForgottenModal(e) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }
      this.$nextTick(() => {
        this.$nuxt.$emit('closeAllModals')
        this.$nuxt.$emit('openPasswordForgottenModal')
      })
    },
  },
}
</script>
